import React, {useState} from 'react';
import {SlideToggle} from '@techsmith/tsc-cloud-style-guide';
import styled from 'styled-components';
import {IUserNotificationPreferenceModel} from '../../model/userNotificationPreferenceModel';
import userApi from '../../service/userApi';

const Container = styled.div`
   margin: 1rem 0 0 0;
`;

export const SettingsToggle: React.FC<ISettingToggleProps> = ({userNotificationSettings, labelText}) => {
   const [isEnabled, setIsEnabled] = useState(userNotificationSettings.some(e => e?.enabled));

   const togglePreference = () => {
      userNotificationSettings.forEach(element => {
         element.enabled = !isEnabled;
         void userApi.manageUserNotificationPreference(element.eventType, element.enabled);
      });
      setIsEnabled(!isEnabled);
   };

   return (
      <Container>
         <SlideToggle
            labelText={labelText}
            isChecked={isEnabled}
            onClick={togglePreference}
         />
      </Container>
   );
};

export interface ISettingToggleProps {
   userNotificationSettings: IUserNotificationPreferenceModel[];
   labelText: string;
}

export default SettingsToggle;
